<table mat-table [dataSource]="itemList" class="mat-elevation gsm-el-table">
  <!--Gewerk Column-->
  <ng-container matColumnDef="gewerk">
    <th mat-header-cell *matHeaderCellDef>Gewerk *</th>
    <td mat-cell *matCellDef="let item">
      <mat-form-field>
        <mat-select
          *ngIf="model.gewerke"
          data-test="gewerkSelect"
          [placeholder]="item.gewerk ? '' : 'Gewerk'"
          required
          [(ngModel)]="item.gewerk"
          (ngModelChange)="onFormValueChange()"
          [disabled]="model?.disabled"
          [compareWith]="gewerkeCompareWithFn"
          #gewerk="ngModel"
        >
          <mat-option *ngFor="let gewerk of model.gewerke" [value]="gewerk">
            {{ gewerk.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </td>
    <td mat-footer-cell *matFooterCellDef>GESAMTSUMME</td>
  </ng-container>
  <!--Kostenvoranschlag Column-->
  <ng-container matColumnDef="kv">
    <th mat-header-cell *matHeaderCellDef>Kostenvoranschlag - Ablöse</th>
    <td mat-cell *matCellDef="let item">
      <mat-checkbox
        data-test="kvCheckbox"
        [(ngModel)]="item.kvAbloese"
        (ngModelChange)="resetItem(item, ['kvAbloese', 'gewerk'])"
        [disabled]="model?.disabled"
      ></mat-checkbox>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>
  <!--Materialkosten Column-->
  <ng-container matColumnDef="matKosten">
    <th mat-header-cell *matHeaderCellDef>Materialkosten [€]</th>
    <td mat-cell *matCellDef="let item">
      <span [ngClass]="{ 'visibility-hidden': !!item.kvAbloese }">
        <mat-form-field>
        <input
          matInput
          name="matAmount"
          type="number"
          min="0"
          placeholder="€"
          step="0.01"
          data-test="materialKostenInput"
          (blur)="onInputBlur(item)"
          [(ngModel)]="item.materialkosten"
          [disabled]="model?.disabled"
        />
          </mat-form-field>
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>
  <!--Arbeitsstunden Column-->
  <ng-container matColumnDef="arbeitsStd">
    <th mat-header-cell *matHeaderCellDef>Arbeitsstunden [h]</th>
    <td mat-cell *matCellDef="let item">
      <mat-form-field>
        <input
          [ngClass]="{ 'visibility-hidden': !!item.kvAbloese }"
          matInput
          name="arbeitsStd"
          data-test="arbeitsStdInput"
          type="number"
          [(ngModel)]="item.arbeitsstunden"
          [pattern]="numberPattern"
          [disabled]="item.anzahlQm || model?.disabled"
          (blur)="onInputBlur(item, $event)"
        />
      </mat-form-field>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>
  <!--Kosten/Arbeitsstunden Column-->
  <ng-container matColumnDef="arbeitsStdKosten">
    <th mat-header-cell *matHeaderCellDef><span>Kosten/</span><span>Arbeitsstunden [h]</span></th>
    <td mat-cell *matCellDef="let item">
      <span [ngClass]="{ 'visibility-hidden': !!item.kvAbloese }">
        <mat-form-field>
        <input
          matInput
          name="stdAmount"
          type="number"
          placeholder="€"
          min="0"
          step="0.01"
          data-test="arbeitsStdKostenInput"
          (blur)="onInputBlur(item)"
          [(ngModel)]="item.stundensatz"
          [disabled]="!item.arbeitsstunden || model?.disabled"
        />
          </mat-form-field>
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>
  <!--m² Column-->
  <ng-container matColumnDef="qm">
    <th mat-header-cell *matHeaderCellDef>Fläche [m²]</th>
    <td mat-cell *matCellDef="let item">
      <mat-form-field>
        <input
          [ngClass]="{ 'visibility-hidden': !!item.kvAbloese }"
          name="qm"
          matInput
          type="number"
          data-test="qmInput"
          [pattern]="numberPattern"
          (blur)="onInputBlur(item, $event)"
          [(ngModel)]="item.anzahlQm"
          [disabled]="item.arbeitsstunden || model?.disabled"
        />
      </mat-form-field>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>
  <!--Kosten/m² Column-->
  <ng-container matColumnDef="qmKosten">
    <th mat-header-cell *matHeaderCellDef>Kosten/m² [€]</th>
    <td mat-cell *matCellDef="let item">
      <span [ngClass]="{ 'visibility-hidden': !!item.kvAbloese }">
        <mat-form-field>
        <input
          matInput
          name="qmAmount"
          type="number"
          placeholder="€"
          min="0"
          step="0.01"
          data-test="qmKostenInput"
          (blur)="onInputBlur(item)"
          [(ngModel)]="item.kostenProQm"
          [disabled]="!item.anzahlQm || model?.disabled"
        />
          </mat-form-field>
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>
  <!--Summe Column-->
  <ng-container matColumnDef="summe">
    <th mat-header-cell *matHeaderCellDef class="gsm-el-table_summe-header">Summe [€]</th>
    <td mat-cell *matCellDef="let item">
      <ng-container *ngIf="!item.kvAbloese">
        <span class="gsm-el-table_summe" [ngClass]="item.summe <= 0 ? 'row-sum-invalid' : null" data-test="el-summe">
          € {{ item.summe || 0 | number: '1.2-2':'de-DE' }}
        </span>
      </ng-container>

      <ng-container *ngIf="item.kvAbloese">
        <mat-form-field>
          <input
            matInput
            name="rowSum"
            type="number"
            min="0"
            placeholder="€"
            step="0.01"
            required
            (focus)="resetItem(item)"
            (blur)="onFormValueChange()"
            [(ngModel)]="item.summe"
            [disabled]="model?.disabled"
          />
        </mat-form-field>
      </ng-container>
    </td>
    <td mat-footer-cell *matFooterCellDef>€ {{ totalSum | number: '1.2-2':'de-DE' }}</td>
  </ng-container>
  <!--Delete Column-->
  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item; let i = index">
      <button mat-icon-button (click)="deleteItem(i)" *ngIf="!model?.disabled">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
</table>

<span class="add-item" *ngIf="!model?.disabled" data-test="gsm-el-table_add" (click)="addItem()">
  <button mat-mini-fab color="primary">
    <mat-icon>add</mat-icon>
  </button>
  <span class="label">Weiteren Eintrag hinzufügen</span>
</span>
